import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
// デフォルトのテーマ
import '@splidejs/splide/css';

document.addEventListener('DOMContentLoaded', function() {
  // '.main_slider' クラスを持つ要素が存在する場合にのみ処理を実行
  if (document.querySelector('.main_slider')) {
    const splide = new Splide('.main_slider', {
      type: 'loop',
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      focus: 'center',
      gap: 40,
      fixedWidth: '480px',
      rewindByDrag: true,
      pagination: true,
      arrowPath: 'M33.8,15.6c-0.1-0.1-0.1-0.3-0.2-0.3L18.8,0.3c-0.1-0.1-0.2-0.2-0.3-0.2C18.3,0,18.2,0,18,0c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.2,0.4l12.6,12.7H1.9c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h27.9L17.2,30.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.3,0,0.4-0.1s0.3-0.1,0.3-0.2l14.8-14.9v0c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4C33.9,15.8,33.9,15.7,33.8,15.6z',
      breakpoints: {
        640: {
          fixedWidth: '80vw',
          gap: '5vw',
        },
      }
    });
    splide.mount();
  }

  // '.contact_slider' クラスを持つ要素が存在する場合にのみ処理を実行
  // speed
  if (document.querySelector('.contact_slider')) {
    const contactSlider = new Splide('.contact_slider', {
      type: 'loop',
      fixedWidth: '33.3333333333%',
      pagination: false,
      arrows: false,
      gap: 0,
      autoScroll: {
        speed: 0.5,
        rewind: true,
        pauseOnHover: false,
      },
      breakpoints: {
        640: {
          width: '100%',
          fixedWidth: '100%',
        },
      }
    });
    contactSlider.mount({ AutoScroll });
  }

  // '.staff_facility' クラスを持つ要素が存在する場合にのみ処理を実行
  if (document.querySelector('.staff_facility')) {
    const facilitySlider = new Splide('.staff_facility', {
     type: 'slide',
      autoplay: false,
      perMove: 1,
      gap: 20,
      width: '100%',
      fixedWidth: '334px',
      lazyLoad: true,
      rewindByDrag: true,
      pagination: false,
      arrowPath: 'M33.8,15.6c-0.1-0.1-0.1-0.3-0.2-0.3L18.8,0.3c-0.1-0.1-0.2-0.2-0.3-0.2C18.3,0,18.2,0,18,0c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.2,0.4l12.6,12.7H1.9c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h27.9L17.2,30.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.3,0,0.4-0.1s0.3-0.1,0.3-0.2l14.8-14.9v0c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4C33.9,15.8,33.9,15.7,33.8,15.6z',
      breakpoints: {
        640: {
          fixedWidth: '80vw',
          gap: '5vw',
          perMove: 1,
        },
      }
    });
    facilitySlider.mount();
  }

  // '.menu_slider' クラスを持つ要素が存在する場合にのみ処理を実行
  if (document.querySelector('.menu_slider')) {
    const menuSlider = new Splide('.menu_slider', {
      type: 'slide',
      autoplay: false,
      perMove: 4,
      gap: 20,
      width: '100%',
      fixedWidth: '334px',
      lazyLoad: true,
      rewindByDrag: true,
      pagination: false,
      arrowPath: 'M33.8,15.6c-0.1-0.1-0.1-0.3-0.2-0.3L18.8,0.3c-0.1-0.1-0.2-0.2-0.3-0.2C18.3,0,18.2,0,18,0c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.2,0.4l12.6,12.7H1.9c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h27.9L17.2,30.1c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.3,0,0.4-0.1s0.3-0.1,0.3-0.2l14.8-14.9v0c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4C33.9,15.8,33.9,15.7,33.8,15.6z',
      breakpoints: {
        640: {
          fixedWidth: '80vw',
          gap: '5vw',
          perMove: 1,
        },
      }
    });
    menuSlider.mount();
  }
});
